module.exports = __webpack_public_path__ + "img/eyeglasses.e6ff5f94.svg";